import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Trash02Icon = (props?: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M10.6667 3.9987V3.46536C10.6667 2.71863 10.6667 2.34526 10.5213 2.06004C10.3935 1.80916 10.1895 1.60519 9.93865 1.47736C9.65344 1.33203 9.28007 1.33203 8.53333 1.33203H7.46667C6.71993 1.33203 6.34656 1.33203 6.06135 1.47736C5.81046 1.60519 5.60649 1.80916 5.47866 2.06004C5.33333 2.34526 5.33333 2.71863 5.33333 3.46536V3.9987M2 3.9987H14M12.6667 3.9987V11.4654C12.6667 12.5855 12.6667 13.1455 12.4487 13.5733C12.2569 13.9497 11.951 14.2556 11.5746 14.4474C11.1468 14.6654 10.5868 14.6654 9.46667 14.6654H6.53333C5.41323 14.6654 4.85318 14.6654 4.42535 14.4474C4.04903 14.2556 3.74307 13.9497 3.55132 13.5733C3.33333 13.1455 3.33333 12.5855 3.33333 11.4654V3.9987"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
